export default __webpack_public_path__ + "static/media/EAST0660.34I-36014_-21028_0.f76e2074.jpg";